module.exports = __webpack_public_path__ + "img/screen-dashboard-webapp.925c03e5.png";